import Layout from '@/layout'

const systemRouter = {
    path: '/system',
    component: Layout,
    redirect: '/system/list',
    name: 'system',
    meta: {
      title: 'routeSystem',
      icon: 'frame2',
      code: 'system'
    },
    children: [
      {
        path: 'sys-user-list',
        component: () => import('@/views/system/sys-user/sys-user-list'),
        name: 'SysUserList',
        meta: { title: 'routeSysUser', icon: 'frame21', code: 'sys:user:management' }
      },
      {
        path: 'sys-role-list',
        component: () => import('@/views/system/sys-role/sys-role-list'),
        name: 'SysRoleList',
        meta: { title: 'routeSysRole', icon: 'frame23', code: 'sys:role:management' }
      },
      {
        path: 'sys-menu-list',
        component: () => import('@/views/system/sys-menu/sys-menu-list'),
        name: 'SysMenuList',
        meta: { title: 'routeSysMenu', icon: 'frame18', code: 'sys:permission:management' }
      },
      {
        path: 'sys-role-menu/:id',
        component: () => import('@/views/system/sys-role/sys-role-menu'),
        name: 'SysRoleMenu',
        meta: { title: '角色权限设置', icon: 'frame18', noCache: true, activeMenu: '/system/sys-role-list', code: 'sys:role-permission:update' },
        hidden: true
      },
      {
        path: 'sys-enterprise',
        component: () => import('@/views/system/sys-enterprise/sys-enterprise-list'),
        name: 'SysEnterpriseList',
        meta: { title: 'routeSysEnterprise', icon: 'frame27', code: 'sys:role:management' }
      }
      // {
      //   path: 'sys-member-list',
      //   component: () => import('@/views/system/sys-member/sys-member-list'),
      //   name: 'SysMemberList',
      //   meta: { title: 'routeSysMember', icon: 'member', code: 'sys:member:page' }
      // }
      // {
      //   path: 'sys-change-list',
      //   component: () => import('@/views/system/sys-change/sys-change-list'),
      //   name: 'SysChangeList',
      //   meta: { title: 'routeSysChange', icon: 'frame27', code: 'sys:role:management' }
      // },
      // {
      //   path: 'sys-tacm-list',
      //   component: () => import('@/views/system/sys-tacm/sys-tacm-list'),
      //   name: 'SysTacmList',
      //   meta: { title: '求援管理', icon: 'hands-helping', code: 'tac:management' }
      // },

    ]
}

export default systemRouter
